import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    changeCurrentPath,
    resetAuth
} from '../../actions';

import Progress from '../../common/containers/progress'
import ReloadModal from '../../common/components/dialog/reload-dialog';
import Login from './components/login';

class Top extends Component {

    constructor(props) {
        super(props);
        this.state = {
            contactOpen:false,
        }
    }

    /** override methods **/
	componentDidMount() {
		const { dispatch, history } = this.props;
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
    componentWillUpdate(nextProps) {
	    if (nextProps.auth.isLoggedIn) {
            this.props.history.push('/main-list');
        }
    }
    componentWillUnmount() {
	    this.props.dispatch(resetAuth());
    }



    render() {
        return (
            <div id="main_container">
                {this.props.auth.isFetching &&
                <Progress/>
                }
                <Login />
                <ReloadModal />
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
	  navigation : state.navigation,
      auth: state.auth
  };
}
export default connect(mapStateToProps)(Top);



// WEBPACK FOOTER //
// ./src/routes/top/index.js